import { Button, Card, Dropdown, Tag, Tooltip, Typography } from "antd";
import {
  PAUSE_OPTIONS,
  STATUS_ABSENT,
  STATUS_PAUSED,
  STATUS_QUEUED,
  statusLabel,
} from "../turnListHelpers";

const { Text } = Typography;

function statusColor(entry) {
  if (entry.is_current) return "green";
  if (entry.status === STATUS_PAUSED) return "orange";
  if (entry.status === STATUS_ABSENT) return "default";
  return "blue";
}

function formatBRL(value) {
  return Number(value || 0).toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });
}

export default function TeamPanel({
  team,
  revenueByErp,
  elapsedNow,
  onPresence,
  onStartLineCut,
  lineCutActive,
  busy,
}) {
  const available = team.filter((row) => row.status === STATUS_QUEUED).length;

  return (
    <Card
      title={
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <span>Equipe de hoje</span>
          <Text type="secondary">
            {available} / {team.length}
          </Text>
        </div>
      }
      styles={{ body: { padding: 0 } }}>
      <div style={{ maxHeight: 420, overflowY: "auto" }}>
        {team.map((row) => (
          <div
            key={row.entry_id}
            style={{
              display: "flex",
              alignItems: "center",
              gap: 8,
              padding: "10px 16px",
              borderBottom: "1px solid rgba(0,0,0,0.06)",
              background: row.is_current ? "rgba(82,196,26,0.08)" : undefined,
            }}>
            <Text type="secondary" style={{ width: 20 }}>
              {row.position + 1}
            </Text>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div
                style={{
                  fontWeight: row.is_current ? 600 : 400,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}>
                {row.seller_name}
              </div>
              <Tag color={statusColor(row)} style={{ marginTop: 2 }}>
                {row.is_current ? "na vez" : statusLabel(row, elapsedNow)}
              </Tag>
            </div>
            <Tooltip title="Vendido hoje (ERP) · atendimentos·vendas na lista">
              <div style={{ textAlign: "right", whiteSpace: "nowrap" }}>
                {revenueByErp && (
                  <div style={{ fontWeight: 600 }}>
                    {formatBRL(revenueByErp[row.erp_code])}
                  </div>
                )}
                <Text type="secondary">
                  {row.attendances}·{row.sales}
                </Text>
              </div>
            </Tooltip>
            {row.status === STATUS_QUEUED && !row.is_current && (
              <Button
                size="small"
                disabled={busy || lineCutActive}
                onClick={() => onStartLineCut(row)}>
                Furar Fila
              </Button>
            )}
            {row.status === STATUS_QUEUED ? (
              <Dropdown
                disabled={busy}
                menu={{
                  items: PAUSE_OPTIONS.map((option) => ({
                    key: option.value,
                    label: option.label,
                  })),
                  onClick: ({ key }) =>
                    onPresence(row.entry_id, STATUS_PAUSED, key),
                }}>
                <Button size="small">Pausar</Button>
              </Dropdown>
            ) : (
              <Button
                size="small"
                disabled={busy}
                onClick={() => onPresence(row.entry_id, STATUS_QUEUED)}>
                Voltar
              </Button>
            )}
            <Button
              size="small"
              type="text"
              danger
              disabled={busy || row.status === STATUS_ABSENT}
              onClick={() => onPresence(row.entry_id, STATUS_ABSENT)}>
              Ausente
            </Button>
          </div>
        ))}
      </div>
    </Card>
  );
}
